import { useTheme } from '@/hooks/useTheme'
import { Moon, Sun, Monitor } from 'lucide-react'

export const ThemeToggle = () => {
  const { mode, toggleTheme } = useTheme()
  const currentModeLabel = mode === 'system' ? 'System' : mode === 'dark' ? 'Dark' : 'Light'
  const nextModeLabel = mode === 'system' ? 'Light' : mode === 'light' ? 'Dark' : 'System'
  const ThemeIcon = mode === 'system' ? Monitor : mode === 'dark' ? Moon : Sun

  return (
    <button
      onClick={toggleTheme}
      className="p-0 w-full h-full flex items-center justify-center transition-colors"
      aria-label={`Theme: ${currentModeLabel}. Switch to ${nextModeLabel} mode`}
      title={`Theme: ${currentModeLabel}`}
    >
      <ThemeIcon
        className="w-4 h-4 text-[#2d2923] [&_*]:fill-current [&_*]:stroke-current"
        strokeWidth={1.75}
        aria-hidden="true"
      />
    </button>
  )
}

export default ThemeToggle 
